import { useTokenContext } from 'contexts/resource/ResourceContext';

const useFormatPoints = () => {
  const { numberingFormat } = useTokenContext();

  const formatPoints = (data: string | number): string => {
    let number = typeof data === 'string' ? Number(data) : data;

    // Round down (floor) to remove decimals without rounding up
    number = Math.floor(number);

    const locale = numberingFormat === 'indian' ? 'en-IN' : 'en-US';
    const formattedNumber = number?.toLocaleString(locale, {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    });
    return `${formattedNumber}`;
  };

  return formatPoints;
};

export default useFormatPoints;
